export default __webpack_public_path__ + "static/media/ed-client.d12182af.webp";